import { render, staticRenderFns } from "./overlay-donation-content.vue?vue&type=template&id=268a0cf7&"
import script from "./overlay-donation-content.vue?vue&type=script&lang=js&"
export * from "./overlay-donation-content.vue?vue&type=script&lang=js&"
import style0 from "./_overlay-donation-content.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports